import $ from 'jquery'
import debounce from 'lodash/debounce'
import escape from 'lodash/escape'
import trim from 'lodash/trim'
import Vue from 'vue'

import '../../../scss/app/unclaimed_capital_credits.scss'

$(document).on('click', '.cc-inquiry-link', (ev) => {
  const $link = $(ev.target)
  const name = trim($link[0].innerText)
  const listingNameWrap = document.querySelector('[data-system-id="listing_name"]')
  if (listingNameWrap) {
    const input = listingNameWrap.querySelector('input')
    if (input) input.value = name
  }
})

const UnclaimedCapitalCredits = Vue.extend({
  // language=HTML
  template: `
    <div class="ucc">
      <div v-if="displayResults && results.length" class="ucc__filter">
        <ui-form-item label="Search the list">
          <ui-form-input v-model="filter.name" />
          <template #help>
            Last Name First
          </template>
        </ui-form-item>
      </div>
      <div 
        class="ucc__results-container"
        :class="{
          'no-results': displayResults && !filteredResults.length
        }"
      >
        <ui-progress-circular
          v-if="loading"
          :size="64"
          :indeterminate="true"
        />

        <template v-if="displayResults">
          <p v-if="!filteredResults.length" class="no-results">
            No results found.
          </p>
          <div v-else class="ucc__results" v-html="resultsHtml"></div>
        </template>
      </div>
    </div>
  `,

  props: ['url', 'claimModal'],

  data() {
    return {
      filter: {
        name: '',
      },
      displayResults: false,
      loading: false,
      results: [],
      filteredResults: [],
    }
  },

  computed: {
    resultsHtml() {
      return this.filteredResults
        .map(
          (result) => `<a 
        class="cc-inquiry-link"
        href="${this.claimModal}"
      >
        ${escape(result)}
      </a>`,
        )
        .join('<br>')
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.debouncedSearch()
      },
    },
  },

  methods: {
    load() {
      this.loading = true
      this.results = []

      $.ajax({
        type: 'GET',
        url: this.url,
        dataType: 'json',
      })
        .always(() => {
          this.loading = false
        })
        .done((results) => {
          this.results = results
          this.displayResults = true
          this.search()
        })
    },

    search() {
      if (!this.filter.name) {
        this.filteredResults = this.results
        return
      }

      this.filteredResults = this.results.filter(
        (result) => result.toLowerCase().indexOf(this.filter.name.toLowerCase()) !== -1,
      )
    },

    debouncedSearch: debounce(function debouncedSearch() {
      this.search()
    }, 500),
  },

  created() {
    this.load()
  },
})

new Vue({
  name: 'UnclaimedCapitalCredits',
  components: {
    'ui-ucc': UnclaimedCapitalCredits,
  },
  el: '.js-entry-point',
})
